import useTranslation from 'next-translate/useTranslation';

import { Typography } from '@core/component';
import { Translate } from '@core/constant';
import { EActionAttribute } from '@core/type';
import { ContactUsBanner } from '@core/widget';

import { CategoriesBlock, SearchBlock } from './components';
import { PageViewFaqProps } from './interface-faq';

export const ViewFaq = ({ ...props }: PageViewFaqProps) => {
  const { t: tFaq } = useTranslation(Translate.page.FAQ);

  return (
    <>
      <Typography as={EActionAttribute.H1} display={'none'}>
        {tFaq('faq')}
      </Typography>
      <SearchBlock />
      <CategoriesBlock {...props} />
      <ContactUsBanner />
    </>
  );
};
